export const feedBack = {
  START_FETCHING_FEEDBACK_DATA:'START_FETCHING_FEEDBACK_DATA',
  START_FETCHING_FEEDBACK_WIDGETS:'START_FETCHING_FEEDBACK_DATA',
  SUCCESS_FETCHING_FEEDBACK_WIDGETS: 'SUCCESS_FETCHING_FEEDBACK_WIDGETS',
  FAILURE_FETCHING_FEEDBACK_WIDGETS: 'FAILURE_FETCHING_FEEDBACK_WIDGETS',
  SUCCESS_FETCHING_FEEDBACK_DATA: 'SUCCESS_FETCHING_FEEDBACK_DATA',
  FAILURE_FETCHING_FEEDBACK_DATA: 'FAILURE_FETCHING_FEEDBACK_DATA',
  CLEAR_FETCHING_FEEDBACK_DATA:'CLEAR_FETCHING_FEEDBACK_DATA',
  CLEAR_FEEDBACK_WIDGETS:'CLEAR_FEEDBACK_WIDGETS'
};
